import { render, staticRenderFns } from "./ChannelPieChart.vue?vue&type=template&id=2291566a&"
import script from "./ChannelPieChart.vue?vue&type=script&lang=js&"
export * from "./ChannelPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports